const notify = {
  state: {
    exportTaskList: [], //导出任务通知列表
    alarmTaskList: [], //严重告警通知列表
  },
  mutations: {
    //导出任务
    PUSH_EXPORTTASKLIST: (state, exportTask) => {
      state.exportTaskList.push(exportTask);
    },
    SET_EXPORTTASK: (state, exportTask) => {
      state.exportTaskList[state.exportTaskList.length - 1] = exportTask;
    },
    REMOVE_EXPORTTASK: (state, i) => {
      state.exportTaskList.splice(i, 1);
    },
    //严重告警
    PUSH_ALARMTASKLIST: (state, alarmTask) => {
      state.alarmTaskList.push(alarmTask);
    },
    SET_ALARMTASK: (state, alarmTask) => {
      state.alarmTaskList[state.alarmTaskList.length - 1] = alarmTask;
    },
    REMOVE_ALARMTASK: (state, i) => {
      state.alarmTaskList.splice(i, 1);
    },
  },
  actions: {
    //导出任务
    PushExportTaskList({ commit }, exportTask) {
      commit("PUSH_EXPORTTASKLIST", exportTask);
    },
    SetExportTask({ commit }, exportTask) {
      commit("SET_EXPORTTASK", exportTask);
    },
    RemoveExportTask({ commit }, i) {
      commit("REMOVE_EXPORTTASK", i);
    },
    //严重告警
    PushAlarmTaskList({ commit }, alarmTask) {
      commit("PUSH_ALARMTASKLIST", alarmTask);
    },
    SetAlarmTask({ commit }, alarmTask) {
      commit("SET_ALARMTASK", alarmTask);
    },
    RemoveAlarmTask({ commit }, i) {
      commit("REMOVE_ALARMTASK", i);
    },
  },
};

export default notify;
